import immutableStore from 'utils/immutableStore';

import alt from 'components/Dispatcher';
import {Record, Map} from 'immutable';
import CrmContactActions from 'actions/crm-opp-ui/CrmContactActions';

@immutableStore
class CrmContactStore {
  constructor() {
    this.state = new Record({
      // last fetched contact
      contact: null,

      // cached list of all fetched contacts.  Triggers uses this
      contacts: Map(),

      searchTerm: null,
      searchResults: null,
      isSearching: false,
    })();

    this.bindActions(CrmContactActions);
  }

  onSearchContacts(term) {
    this.setState({
      isSearching: true,
      searchTerm: term,
    });
  }

  searchContactsSuccess(entities) {
    this.setState({
      isSearching: false,
      searchResults: entities,
    });
  }

  searchContactsError(response) {
    console.warn(response);
    this.setState({
      isSearching: false,
      searchResults: null,
    });
  }

  fetchContactSuccess(contact) {
    this.setState({
      contact,
      contacts: this.state.contacts.set(contact.id, contact),
    });
  }

  fetchContactError(response) {
    console.warn(response);
    this.setState({
      contact: null,
    });
  }

  onClearSearch() {
    this.setState({
      searchTerm: null,
      searchResults: null,
      isSearching: false,
    });
  }

  onSetSearchTerm(term) {
    this.setState({
      searchTerm: term,
    });
  }
}

export default alt.createStore(CrmContactStore, 'CrmContactStore');
